<div class="dashboard-date-selector">
  <!-- Desktop View -->
  <div class="filter-item desktop-view">
    <div class="date-fields">
      <!-- Input Data Inicial -->
      <div class="custom-date-input">
        <input
          type="date"
          [(ngModel)]="startDate"
          (change)="onDateChange()"
          [max]="endDate || today"
          class="date-input-native"
          #startDateInput
          (click)="startDateInput.showPicker()"
        >
        <div class="date-display" (click)="startDateInput.showPicker()">
          {{ getDisplayDate(startDate) || 'DD/MM/AAAA' }}
        </div>
        <img
          src="assets/icons/arrowDownCalendar.png"
          alt="Calendário"
          class="calendar-icon"
          (click)="startDateInput.showPicker()"
        >
      </div>

      <!-- Separador -->
      <span class="date-separator">a</span>

      <!-- Input Data Final -->
      <div class="custom-date-input">
        <input
          type="date"
          [(ngModel)]="endDate"
          (change)="onDateChange()"
          [min]="startDate"
          [max]="today"
          class="date-input-native"
          #endDateInput
          (click)="endDateInput.showPicker()"
        >
        <div class="date-display" (click)="endDateInput.showPicker()">
          {{ getDisplayDate(endDate) || 'DD/MM/AAAA' }}
        </div>
        <img
          src="assets/icons/arrowDownCalendar.png"
          alt="Calendário"
          class="calendar-icon"
          (click)="endDateInput.showPicker()"
        >
      </div>
    </div>

    <!-- Botão Limpar (apenas quando houver datas) -->
    <button class="clear-button" (click)="clearDates()" *ngIf="startDate || endDate">
      Limpar
    </button>
  </div>

  <!-- Mobile View - Button que abre popup -->
  <div class="filter-item mobile-view">
    <button class="mobile-date-button" (click)="openDatePickerModal()">
      <span class="mobile-date-text">
        {{ getDisplayDate(startDate) || 'DD/MM/AAAA' }}
        <span class="date-separator"> a </span>
        {{ getDisplayDate(endDate) || 'DD/MM/AAAA' }}
      </span>
            <img src="assets/icons/arrowDownCalendar.png" alt="Calendário" class="calendar-icon">

    </button>
    <button class="clear-button-mobile" (click)="clearDates()" *ngIf="startDate || endDate">
      Limpar
    </button>
  </div>

  <!-- Modal/Popup para Mobile -->
  <div class="date-picker-modal" *ngIf="isModalOpen" [class.active]="isModalOpen">
    <div class="modal-overlay" (click)="closeeDatePickerModal()"></div>
    <div class="modal-content">
      <div class="modal-header">
        <h3>Selecionar Período</h3>
        <button class="close-button" (click)="closeeDatePickerModal()">✕</button>
      </div>

      <div class="modal-body">
        <!-- Data Inicial -->
        <div class="modal-date-section">
          <label class="modal-label">Data Inicial</label>
          <div class="custom-date-input">
            <input
              type="date"
              [(ngModel)]="startDate"
              [max]="endDate || today"
              class="date-input-native"
              #modalStartDateInput
              (click)="modalStartDateInput.showPicker()"
            >
            <div class="date-display" (click)="modalStartDateInput.showPicker()">
              {{ getDisplayDate(startDate) || 'DD/MM/AAAA' }}
            </div>
            <img
              src="assets/icons/arrowDownCalendar.png"
              alt="Calendário"
              class="calendar-icon"
              (click)="modalStartDateInput.showPicker()"
            >
          </div>
        </div>

        <!-- Data Final -->
        <div class="modal-date-section">
          <label class="modal-label">Data Final</label>
          <div class="custom-date-input">
            <input
              type="date"
              [(ngModel)]="endDate"
              [min]="startDate"
              [max]="today"
              class="date-input-native"
              #modalEndDateInput
              (click)="modalEndDateInput.showPicker()"
            >
            <div class="date-display" (click)="modalEndDateInput.showPicker()">
              {{ getDisplayDate(endDate) || 'DD/MM/AAAA' }}
            </div>
            <img
              src="assets/icons/arrowDownCalendar.png"
              alt="Calendário"
              class="calendar-icon"
              (click)="modalEndDateInput.showPicker()"
            >
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="button-cancel" (click)="closeeDatePickerModal()">Cancelar</button>
        <button class="button-confirm" (click)="confirmDateSelection()">Confirmar</button>
      </div>
    </div>
  </div>
</div>
